import { Button, Input, Select, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";

function ControlBox ({stateHandler}) {

  return (
    <Space wrap style={{justifyContent: "end"}}>
      <Button onClick={()=>{stateHandler("createModal", true)}}>
        <PlusOutlined />프롬프트 명칭 추가
      </Button>
    </Space>
  )
}

export default ControlBox